module.exports = __webpack_public_path__ + "media/images/sp/stores/karuizawa/karuizawa_concept_04-92a543f24ecf0db2cc9cb29d66a6354e.jpg";